<template>
  <section>
    <h1 class="section-head">ใบเสนอราคา {{ quotation.code }} - {{ quotation.company }}</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" :to="backPage"><i class="fas fa-arrow-left"></i>Back</router-link>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <span v-can="'download_quotation_pdf'" class="margin-left-5">
              <button class="button is-info" @click="download"><i class="fas fa-download"></i> ดาวโหลดใบเสนอราคา</button>
            </span>
            <span class="margin-left-5">
              <button class="button is-success" @click="copyToOrder" v-if="quotation.ord_id == '0'" v-can="'add_order'"><i class="fas fa-copy"></i> ทำสำเนาเป็นคำสั่งซื้อ</button>
            </span>
            <span v-can="'edit_quotation|add_quotation'" class="margin-left-5">
              <router-link class="button is-warning" :to="'/quotation/edit/' + this.$route.params.id" v-if="quotation.status != 'received'"><i class="fas fa-pencil-alt"></i>แก้ไข</router-link>
            </span>
          </div>
        </div>
      </div>
    </nav>

    <div class="margin-botton-10">
      <h1 class="section-sub-head">รายละเอียดใบเสนอราคาจากลูกค้า</h1>
    </div>
    <div class="columns">
      <div class="column">
        <p><strong>To:</strong> {{ quotation.name || '-' }}</p>
        <p><strong>Company:</strong> {{ quotation.company || '-' }}</p>
        <p><strong>Address:</strong> {{ quotation.address || '-' }}</p>
        <p><strong>Phone:</strong> {{ quotation.phone || '-' }}</p>
        <p><strong>Fax.:</strong> {{ quotation.fax || '-' }}</p>
        <p><strong>E-Mail:</strong> {{ quotation.email || '-' }}</p>
      </div>
      <div class="column">
        <p><strong>เลขที่ใบเสนอราคา:</strong> {{ quotation.code || '-' }}</p>
        <p v-if="quotation.ord_id != 0" v-can="'view_order|edit_order|issue_tax_invoice|issue_receipt'">
          <strong>เลขที่คำสั่งซื้อ: </strong> <router-link :to="'/order/view/' + this.quotation.ord_id">{{ order.code || '-' }}</router-link>
        </p>
      </div>
    </div>

    <div>
      <b-table class="table-style" :data="quotation.items" :hoverable="true" :loading="isLoading" v-if="quotation.items || isLoading">
        <template slot-scope="props">
          <b-table-column field="name" label="ชื่อผลิตภัณฑ์" width="250">
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="price_sell" label="ราคาขาย" width="130"> {{ parseFloat(props.row.price).formatMoney(2) }} บาท/{{ unitList[props.row.unit] }} </b-table-column>

          <b-table-column label="ส่วนลด(%)" width="80">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static is-small" type="text" placeholder="ส่วนลด %" :value="props.row.discount + '%'" readonly />
              </p>
            </div>
          </b-table-column>

          <b-table-column label="ส่วนลด(฿)" width="80">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static is-small" type="text" placeholder="ส่วนลด ฿" :value="props.row.discount_baht + ' บาท'" readonly />
              </p>
            </div>
          </b-table-column>

          <b-table-column field="price_sell" label="จำนวนสั่ง" width="80">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static  is-small" type="text" placeholder="จำนวนสั่ง" :value="parseFloat(props.row.amount).formatMoney(0) + ' ' + unitList[props.row.unit]" readonly />
              </p>
            </div>
          </b-table-column>

          <b-table-column label="รวม" width="130">
            <input class="input is-static  is-small" type="text" placeholder="รวม" :value="parseFloat(props.row.total_price).formatMoney(2) + ' บาท'" readonly />
          </b-table-column>

          <b-table-column label="Remark" width="250">
            <input class="input is-static  is-small" type="text" placeholder="Remark" :value="props.row.remark" readonly />
          </b-table-column>
        </template>
      </b-table>

      <div class="notification has-text-centered" v-else>ไม่มีรายการผลิตภัณฑ์</div>
    </div>
  </section>
</template>

<script>
import Request from '@/libraries/request';
import QuotationModel from '@/model/quotation_model';
import OrderModel from '@/model/order_model';
import Const from '@/const/const';
import Config from '@/libraries/config';

export default {
  data() {
    return {
      order: {},
      quotation: [],
      unitList: Const.product_unit,
      isLoading: true,
      backPage: '/quotation',
      products: [],
      alert: {
        supplier: {
          type: '',
          msg: '',
        },
      },
      loadingClass: '',
    };
  },
  mounted() {
    this.isLoading = true;
    this.init();
  },
  methods: {
    async init() {
      try {
        if (this.$route.params.id) {
          const quotation = await QuotationModel.get_quotation(this.$route.params.id);
          this.quotation = quotation[0];
          if (this.quotation.ord_id != 0) {
            const order = await OrderModel.get_order(this.quotation.ord_id);
            this.order = order[0];
          }
        }
        this.isLoading = false;
      } catch (e) {
        this.$buefy.snackbar.open(e.message);
        this.$router.push('/quotation');
      }
    },
    updateStatus(which) {
      if (typeof which === 'undefined') {
        return;
      }
      let data = {};
      data.id = this.$route.params.id;
      if (which == 'shipment_status') {
        this.quotation.ship_status = this.quotation.ship_status == '1' ? '0' : '1';
      }
      if (which == 'payment_status') {
        this.quotation.payment_status = this.quotation.payment_status == '1' ? '0' : '1';
      }
      data.ship_status = this.quotation.ship_status;
      data.payment_status = this.quotation.payment_status;
      Request.post('quotation/update_status', data, res => {
        this.isLoading = false;
        this.loadingClass = '';
        if (res.data.status) {
          this.quotation = res.data.data;
          this.$buefy.snackbar.open('แก้ไขสถานะสำเร็จ!');
        }
      });
    },
    download() {
      window.open(Config.baseUrl + '/' + this.quotation.pdf_path);
    },
    copyToOrder() {
      let order = Object.assign({}, this.quotation);
      delete order.id;
      delete order.pdf_path;
      delete order.code;
      delete order.code_id;
      delete order.total_price;
      delete order.year;
      delete order.items;
      order.items = [];

      for (const [key, value] of Object.entries(this.quotation.items)) {
        console.log(key, value);
        let item = {};
        item.id = value.pro_id;
        item.amount = value.amount;
        item.discount = value.discount;
        item.discount_baht = value.discount_baht;
        item.remark = value.remark ? value.remark : '';
        order.items.push(item);
      }

      Request.post('order/add', order, res => {
        this.isLoading = false;
        this.loadingClass = '';
        if (res.data.status) {
          if (res.data.data.id) {
            let quotationUpdate = {};
            quotationUpdate.ord_id = res.data.data.id;
            quotationUpdate.id = this.$route.params.id;
            Request.post('quotation/update_order_id', quotationUpdate, resUpdate => {
              this.$buefy.snackbar.open('ทำสำเนาสำเร็จ!');
              this.$router.push({ path: '/order/view/' + res.data.data.id });
            });
          } else {
            this.$router.push({ path: '/order' });
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.table-style {
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Quotation/view.vue